import { selectForethoughtLiveChatWidgetComponent } from 'reducers/workflows';
import { DeploymentConfiguration } from './types';
import store from 'store';
import {
  selectChatId,
  selectLiveChatJwt,
  setLiveChatId,
  setLiveChatJwt,
} from 'reducers/live-chat';

function getOrganizationId() {
  const forethoughtLiveChatWidgetComponent =
    selectForethoughtLiveChatWidgetComponent(store.getState());

  if (
    forethoughtLiveChatWidgetComponent?.component_fields.integration_config
      .integration === 'salesforce'
  ) {
    return forethoughtLiveChatWidgetComponent?.component_fields
      .integration_config.integration_fields.organization_id;
  }

  return '';
}

function getDeploymentDeveloperName() {
  const forethoughtLiveChatWidgetComponent =
    selectForethoughtLiveChatWidgetComponent(store.getState());

  if (
    forethoughtLiveChatWidgetComponent?.component_fields.integration_config
      .integration === 'salesforce'
  ) {
    return forethoughtLiveChatWidgetComponent?.component_fields
      .integration_config.integration_fields.developer_name;
  }

  return '';
}

function getSalesforceMessagingUrl() {
  const forethoughtLiveChatWidgetComponent =
    selectForethoughtLiveChatWidgetComponent(store.getState());

  if (
    forethoughtLiveChatWidgetComponent?.component_fields.integration_config
      .integration === 'salesforce'
  ) {
    return forethoughtLiveChatWidgetComponent?.component_fields
      .integration_config.integration_fields.scrt_url;
  }

  return '';
}

function setJwt(newJwt: string) {
  store.dispatch(setLiveChatJwt(newJwt));
}

function getJwt() {
  return selectLiveChatJwt(store.getState());
}

let configuration: DeploymentConfiguration | undefined;
function setDeploymentConfiguration(newConfiguration: DeploymentConfiguration) {
  configuration = newConfiguration;
}
function getDeploymentConfiguration() {
  return configuration;
}

// Store the latest last-event-id from the Access Token API response or from an Event Source (SSE) event in-memory.
let lastEventId: string | undefined;
function setLastEventId(id: string) {
  lastEventId = id;
}
function getLastEventId() {
  return lastEventId;
}

function storeConversationId(convId: string) {
  store.dispatch(setLiveChatId(convId));
}
function getConversationId() {
  return selectChatId(store.getState());
}

// Clears the in-memory messaging data variables.
function clearInMemoryData() {
  lastEventId = undefined;
}

export const clearWebStorage = () => {
  configuration = undefined;
};

export {
  getOrganizationId,
  getDeploymentDeveloperName,
  getSalesforceMessagingUrl,
  setDeploymentConfiguration,
  getDeploymentConfiguration,
  setLastEventId,
  getLastEventId,
  setJwt,
  getJwt,
  storeConversationId,
  getConversationId,
  clearInMemoryData,
};
